import { closeMenu } from "../../blocks/layout/header/menu/menu";
import axios from "axios";
// import axios from "axios";

const timeouts = [];
const main = document.querySelector(".main");
const links = document.querySelectorAll(".menu__link");

const openClass = "open";
const initURL = "/form_init";
const filesURL = "/form_files";
const sendURL = "/form_send";
let trigger, block, form, button;
let caption, progress, progressBox, steps, completed, files;

const fillBlocks = () => {
  trigger = document.getElementById("e_trigger");
  block = document.querySelector(".expand");
  form = document.getElementById("material-form");
  button = form?.querySelector('button[type="submit"]');
};

const checkExpand = () => {
  if (trigger && trigger.checked) block.classList.add(openClass);
  else block.classList.remove(openClass);
};

const expander = () => {
  trigger.addEventListener("change", checkExpand);
};

const expanderOut = () => {
  trigger.removeEventListener("change", checkExpand);
};

const setProgress = (step) => {
  if (!progress) return;
  const percent = (100 / steps) * step;
  progress.style.width = percent + "%";
  completed = step;
};

const switchProgress = (show) => {
  if (!progressBox) return;
  if (show) progressBox.classList.add("show");
  else progressBox.classList.remove("show");
};

const initSend = () => {
  return new Promise((resolve, reject) => {
    files = [];
    steps = 2;
    completed = 0;
    const fd = new FormData(form);
    const toUnset = [];
    for (const pair of fd.entries()) {
      if (typeof pair[1] === "object") {
        toUnset.push(pair[0]);
        if (pair[1]?.size ?? false) {
          steps++;
          files.push(pair);
        }
      }
    }
    if (toUnset.length) toUnset.forEach((entryName) => fd.delete(entryName));
    axios
      .post(initURL, fd)
      .then((response) => {
        setProgress(1);
        resolve(response.data);
      })
      .catch(reject);
  });
};

async function fileUploadPromiseFactory(uploadId, filePair) {
  return new Promise((resolve) => {
    const fd = new FormData();
    fd.append("upload", uploadId);
    fd.append(filePair[0], filePair[1]);
    axios
      .post(filesURL, fd)
      .then(() => {
        setProgress(++completed);
        resolve();
      })
      .catch(() => {
        throw new Error("not upload");
      });
  });
}

async function uploadFiles(uploadId) {
  for (let i = 0; i < files.length; i++) {
    await fileUploadPromiseFactory(uploadId, files[i]);
  }
  return uploadId;
}

const send = (uploadId) => {
  return new Promise((resolve, reject) => {
    axios
      .post(sendURL, { upload: uploadId })
      .then((response) => {
        setProgress(steps);
        resolve(response.data);
      })
      .catch(reject);
  });
};

const finish = () => {
  button.innerHTML = button.dataset.completed;
  switchProgress(false);
};

const errorReset = () => {
  alert("Ошибка, попробуйте позже");
  button.innerHTML = caption;
  switchProgress(false);
};

const formSendTrigger = () => {
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    progressBox = form.querySelector("div.progress");
    progress = form.querySelector("div.progress > div");
    setProgress(0);
    caption = button.innerHTML;
    button.innerHTML = button.dataset.process;
    switchProgress(true);
    initSend().then(uploadFiles).then(send).then(finish).catch(errorReset);
  });
};

export default {
  enterAction: () => {
    return new Promise((resolve) => {
      main.classList.remove("main_hidden");

      links.forEach((link) => {
        if (
          link.pathname.split("/")[1] === window.location.pathname.split("/")[1]
        ) {
          link.classList.add("menu__link_current");
        } else {
          link.classList.remove("menu__link_current");
        }
      });
      fillBlocks();
      checkExpand();
      expander();
      formSendTrigger();

      timeouts.push(
        setTimeout(() => {
          resolve();
        }, 500)
      );
    });
  },
  exitAction: () => {
    return new Promise((resolve) => {
      main.scrollTo(0, 0);
      closeMenu();
      expanderOut();
      main.classList.add("main_hidden");

      timeouts.push(
        setTimeout(() => {
          resolve();
        }, 500)
      );
    });
  },
  breakAction: () => {
    timeouts.map(clearTimeout);
  }
};
